/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IlsDescription } from '../../models/ils-description';

export interface IlsControllerFindIlsDescription$Params {
  ilsId: string;
}

export function ilsControllerFindIlsDescription(http: HttpClient, rootUrl: string, params: IlsControllerFindIlsDescription$Params, context?: HttpContext): Observable<StrictHttpResponse<IlsDescription>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerFindIlsDescription.PATH, 'get');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IlsDescription>;
    })
  );
}

ilsControllerFindIlsDescription.PATH = '/ils/{ilsId}/description';
